import React from 'react';
import { Button, Modal } from 'antd';
import type { PanelStatus } from 'types/credentialing';
import { AllState } from 'constants/common';
import { EFeatureType } from 'types/provider';
import HomeStore from 'store/Home';

const getStateName = (code?: string) => AllState.find((i) => i.dictKey === code)?.content || code || '';

interface Props {
    // 待重提的 panel 行；null 时不显示
    target: PanelStatus | null;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

// 重提 withdrawn panel 的确认弹窗（与 WithdrawPayerModal 同款结构：后果前置——从头开始、重新收押金、回到 review）
export default function ResubmitPayerModal({ target, loading, onCancel, onConfirm }: Props) {
    const stateName = getStateName(target?.state);
    // 押金被 Ops 减免的账号没有押金可收 / 可退，去掉押金那句
    const [getHomeStore] = HomeStore.useStore();
    const feeWaived = !!getHomeStore('data')?.features?.includes(EFeatureType.CREDENTIALING_FEE_WAIVED);
    return (
        <Modal
            open={!!target}
            onCancel={onCancel}
            title={`Resubmit ${target?.name || ''}${stateName ? ` (${stateName})` : ''}?`}
            width={543}
            centered
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button key="resubmit" type="primary" loading={loading} onClick={onConfirm}>
                    Resubmit
                </Button>,
            ]}
        >
            <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.6, margin: 0 }}>
                This restarts your {target?.name} application{stateName ? ` in ${stateName}` : ''} from scratch.
                {feeWaived
                    ? ' It goes back into review.'
                    : ' A new deposit will be charged for this panel, and it goes back into review.'}
            </p>
        </Modal>
    );
}
